import {request} from '@/helpers/apiClient'
import {PRODUCT_CATALOG_CONFIG} from '@/utils/constants/apiConfig/productCatalogConfig'

export const getCatalog = () => {
  return request(PRODUCT_CATALOG_CONFIG.GET_CATALOG)
}

export const deleteBrandImage = brandId => {
  return request(PRODUCT_CATALOG_CONFIG.DELETE_BRNAD_IMAGE(brandId))
}

export const updateCatalog = productCatalogData => {
  return request(PRODUCT_CATALOG_CONFIG.UPDATE_CATALOG, {
    data: productCatalogData,
  })
}
